module.exports = __webpack_public_path__ + "img/software-thumb-2.1dcd5965.webp";